import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const javascript = `const signalR = require("@microsoft/signalr"); 
// Handshaking
const token = <token_here>;
let connection = new signalR.HubConnectionBuilder()
.withUrl("<base_url>/transactional", { accessTokenFactory: () => token })
.build(); 
// Subscriptions
connection.on("<Subscription Method Name>", (data) => { console.log(data);
}); 
start(); 
function start() { connection.start()
.then(() => {
// more code
});
};`;

function EFDAAF() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={javascript}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default EFDAAF;
